module.exports = __webpack_public_path__ + "static/media/analyticsLogo.7bb3c155.svg";